<template>
    <div class="news flex">
        <div class="flex-1">
            <div class="flex flex-between align-center">
                <div class="fc-theme fs-24">电商头条</div>
                <div class="more point" @click="pushUrl('http://ask.vv-tool.cn')">更多 ></div>
            </div>
            <ul class="marginT-20">
                <li class="item flex flex-between align-center point" v-for="(item, index) in tt.slice(0, 5)" :key="index" @click="pushUrl(item.url)">
                    <div class="title fc-333 marginT-10">{{item.title}}</div>
                    <div class="fc-999 date marginT-10">{{parseDate(item.created_at)}}</div>
                </li>
            </ul>
        </div>
        <div class="flex-1">
            <div class="flex flex-between align-center">
                <div class="fc-theme fs-24">API接口描述</div>
                <div class="more point" @click="pushUrl(goApiUrl())">更多 ></div>
            </div>
            <ul class="marginT-20">
                <li class="item flex flex-between align-center point" v-for="(item, index) in doc.slice(0, 5)" :key="index" @click="pushUrl(goApiUrl() + '/taobao/' + item.api_code)">
                    <div class="title fc-333 marginT-10">{{item.api_name + ': ' + item.api_desc}}</div>
                    <div class="fc-999 date marginT-10">{{'11-26'}}</div>
                </li>
            </ul>
        </div>
        <div class="flex-1">
            <div class="flex flex-between align-center">
                <div class="fc-theme fs-24">电商知识库</div>
                <div class="more point" @click="pushUrl('http://ask.vv-tool.cn')">更多 ></div>
            </div>
            <ul class="marginT-20">
                <li class="item flex flex-between align-center point" v-for="(item, index) in info.slice(0, 5)" :key="index" @click="pushUrl(item.url)">
                    <div class="title fc-333 marginT-10">{{item.title}}</div>
                    <div class="fc-999 date marginT-10">{{parseDate(item.created_at)}}</div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    props: {
        tt: {
            type: Array,
            default() {
                return []
            }
        },
        doc: {
            type: Array,
            default() {
                return []
            }
        },
        info: {
            type: Array,
            default() {
                return []
            }
        },
    },
    computed: {
        ...mapState(['configData']),
    },
    data() {
        return {
        }
    },
    methods: {
        pushUrl(url) {
            window.open(url)
        },
        goApiUrl() {
            if (this.isToolMainSite()) {
                return 'http://doc.vv-tool.cn'
            }else {
                return this.configData.proxy_info.site_doc_host
            }
        },
        parseDate(Data) {
            const mouth = new Date(Data).getMonth() + 1
            const day = new Date(Data).getDate()
            return `${mouth}-${day}`
        },
    },
    mounted () {
        // this.getInfo()
        // this.getDoc()
    },
}
</script>

<style lang="scss" scoped>
.news {
    & > div {
        width: 300px;
        & + div {
            margin-left: 40px;
        }
    }
    .more {
        color: #666;
    }
    .title {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &:hover {
            color: #ff6464;
        }
    }
    .date {
        flex-basis: 80px;
        text-align: right;
    }
}
</style>
